const env_local = 'local' as const;
const env_dev = 'dev' as const;
const env_staging = 'staging' as const;
const env_prod = 'prod' as const;
const env_aquarium_1 = 'aquarium-1' as const;

const SupportedEnvs = [env_local, env_dev, env_staging, env_prod, env_aquarium_1] as const;
type Envs = typeof SupportedEnvs[number];

type Created = {
	'defaultConfigUrl': string,
	'configUrl': string
};
type EnvConfigs = { [key in Envs]: Created };
const envs: EnvConfigs = {
	'local': {
		'defaultConfigUrl': 'http://127.0.0.1:8304/_frontend/default.json?ns=quai-md-runtime-local',
		'configUrl': 'http://127.0.0.1:8304/_frontend/advisor.json?ns=quai-md-runtime-local'
	},
	'dev': {
		'defaultConfigUrl': 'https://quai-md-runtime-dev-default-rtdb.firebaseio.com/_frontend/default.json',
		'configUrl': 'https://quai-md-runtime-dev-default-rtdb.firebaseio.com/_frontend/advisor.json'
	},
	'staging': {
		'defaultConfigUrl': 'https://quai-md-runtime-staging-default-rtdb.firebaseio.com/_frontend/default.json',
		'configUrl': 'https://quai-md-runtime-staging-default-rtdb.firebaseio.com/_frontend/advisor.json'
	},
	'prod': {
		'defaultConfigUrl': 'https://quai-md-runtime-default-rtdb.firebaseio.com/_frontend/default.json',
		'configUrl': 'https://quai-md-runtime-default-rtdb.firebaseio.com/_frontend/advisor.json'
	},
	'aquarium-1': {
		'defaultConfigUrl': 'https://quai-md-runtime-aquarium-1-default-rtdb.firebaseio.com/_frontend/default.json',
		'configUrl': 'https://quai-md-runtime-aquarium-1-default-rtdb.firebaseio.com/_frontend/advisor.json'
	}
};

type DomainToEnv = Record<string, Envs>;
const domainsToEnv: DomainToEnv = {
	'localhost:8301': 'local',
	'127.0.0.1:8301': 'local',
	'advisor.dev.quaimd.com': 'dev',
	'advisor-dev.quai.md': 'dev',
	'quai-md-runtime-dev.firebaseapp.com': 'dev',
	'quai-md-runtime-dev.web.app': 'dev',
	'advisor.staging.quaimd.com': 'staging',
	'advisor-staging.quai.md': 'staging',
	'quai-md-runtime-staging.firebaseapp.com': 'staging',
	'quai-md-runtime-staging.web.app': 'staging',
	'advisor.quaimd.com': 'prod',
	'advisor.quai.md': 'prod',
	'quai-md-runtime.firebaseapp.com': 'prod',
	'quai-md-runtime.web.app': 'prod',
	'advisor.aquarium-1.quaimd.com': 'aquarium-1',
	'quai-md-runtime-aquarium-1.firebaseapp.com': 'aquarium-1',
	'quai-md-runtime-aquarium-1.web.app': 'aquarium-1',
};

export const deriveConfig = () => {
	window.location.host;
	const recognizedEnv = domainsToEnv[window.location.host];
	if (!recognizedEnv)
		throw new Error(`Unrecognized env for domain: ${window.location.host}`);

	return envs[recognizedEnv];
};